import { createSelector } from 'redux-starter-kit';

const isImportingPoliciesSelector = (state: any) => state.importPolicies;

export const importingPoliciesSelectors = {
  isImportingPolicies: createSelector(
    isImportingPoliciesSelector,
    subState => subState.isImporting
  )
};
